export interface ApplicationSubmitToFccResponse {
    applicationId: number;
    submissionStatus: ApplicationSubmitToFccStatus;
    filingStatus: string;
    message?: string;
}

export enum ApplicationSubmitToFccStatus {
    Submitted = 1,
    FailedValidation = 2,
    NoSelectedFrequenciesError = 3,
    NoSelectedFrequenciesWarning = 4,
    AttachmentRequired = 5,
}
